import React from "react";
import { Modal } from "react-bootstrap";
import SignupForm from "../Signup/SignupForm";

const AddUser = ({ show, handleClose, onUserCreated }) => {
 
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        className="conversion_modal"
      >
        <>
          <Modal.Header closeButton>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <SignupForm handleClose={handleClose} onUserCreated={onUserCreated} isAdd />
            </div>
          </Modal.Body>
        </>
      </Modal>
    </>
  );
};

export default AddUser;
